import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { id: "home", label: "Home", url: "/" },
  { id: "about", label: "About Us", url: "/about" },
  { id: "services", label: "Services", url: "/services" },
  { id: "projects", label: "Projects", url: "/projects" },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState("home");
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToContact = () => {
    setMenuOpen(false);
    if (location.pathname === "/") {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const currentItem = navItems.find((item) => item.url === currentPath);
    if (currentItem) {
      setActiveItem(currentItem.id);
    }
    setMenuOpen(false);
  }, [location]);

  const linkClass = (id) => `
    relative cursor-pointer transition-colors duration-300
    hover:text-orange-500
    after:content-[''] after:absolute after:left-0 after:bottom-[-4px]
    after:h-[2px] after:bg-orange-500 after:transition-all after:duration-300
    ${activeItem === id ? "text-orange-500 after:w-full" : "after:w-0 hover:after:w-full"}
  `;

  return (
    <nav className="sticky top-0 z-50 w-full bg-white shadow-sm px-6 py-4 flex items-center justify-between">
      {/* Logo */}
      <Link to="/" className="flex items-center gap-2">
        <img src="/logo.png" alt="Logo" className="h-9" />
        <span className="font-bold text-sm md:text-base lg:text-lg leading-tight">
            <span className="md:hidden">ATPPL</span>
            <span className="hidden md:inline">Aditya Techno Products Pvt Limited</span>
          </span>
      </Link>

      {/* Desktop Nav (lg and above) */}
      <ul className="hidden lg:flex lg:gap-8 lg:text-sm font-medium text-gray-700">
        {navItems.map((item) => (
          <li key={item.id}>
            <Link to={item.url} className={linkClass(item.id)}>
              {item.label}
            </Link>
          </li>
        ))}
      </ul>

      {/* Right side */}
      <div className="flex items-center gap-3">
        <button onClick={scrollToContact} className="bg-gray-100 px-3 py-1.5 md:px-4 md:py-2 rounded-md text-sm font-medium hover:bg-orange-500 hover:text-white transition-colors duration-200">
          Contact Us
        </button>

        {/* Hamburger - mobile & medium */}
        <button
          className="lg:hidden flex flex-col justify-center items-center w-9 h-9 gap-1.5"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle menu"
        >
          <span
            className={`block h-0.5 w-6 bg-gray-700 transition-all duration-300 ${
              menuOpen ? "rotate-45 translate-y-2" : ""
            }`}
          />
          <span
            className={`block h-0.5 w-6 bg-gray-700 transition-all duration-300 ${
              menuOpen ? "opacity-0" : ""
            }`}
          />
          <span
            className={`block h-0.5 w-6 bg-gray-700 transition-all duration-300 ${
              menuOpen ? "-rotate-45 -translate-y-2" : ""
            }`}
          />
        </button>
      </div>

      {/* Mobile & Medium Dropdown */}
      {menuOpen && (
        <ul className="absolute top-full left-0 w-full bg-white shadow-md flex flex-col px-6 py-4 gap-4 font-medium text-gray-700 lg:hidden">
          {navItems.map((item) => (
            <li key={item.id}>
              <Link to={item.url} className={linkClass(item.id)}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}
